import { render, staticRenderFns } from "./SurveyInfo.vue?vue&type=template&id=a8986e74&"
import script from "./SurveyInfo.vue?vue&type=script&lang=js&"
export * from "./SurveyInfo.vue?vue&type=script&lang=js&"
import style0 from "./SurveyInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports